import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fileUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path; // vídeo externo (uno.lermahoy.es)
  return `${API}/files/${path}`;
};

export async function fetchMonuments() {
  const { data } = await api.get("/monuments");
  return data;
}

export async function fetchWelcome() {
  const { data } = await api.get("/welcome");
  return data.text;
}

export async function createCheckout(sessionId) {
  const { data } = await api.post("/payments/checkout", {
    origin_url: window.location.origin,
    session_id: sessionId,
  });
  return data;
}

export async function checkPaymentStatus(sessionId) {
  const { data } = await api.get(`/payments/status/${sessionId}`);
  return data;
}

// Streaming chat via fetch + ReadableStream (SSE)
export async function streamChat({ sessionId, message, monumentId }, onDelta, onDone, onError) {
  try {
    const res = await fetch(`${API}/chat`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId, message, monument_id: monumentId }),
    });
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop();
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith("data:")) continue;
        const payload = JSON.parse(line.slice(5).trim());
        if (payload.delta) onDelta(payload.delta);
        else if (payload.error) onError(payload.error);
        else if (payload.done) onDone();
      }
    }
    onDone();
  } catch (e) {
    onError("No se pudo conectar con Catalina.");
  }
}

export async function submitContact(message, email) {
  const { data } = await api.post("/contact", { message, email });
  return data;
}